module.exports = __webpack_public_path__ + "img/msg_logo.50615c64.png";